import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class bookingDetailModel extends Model {

    defaults() {
        return {
            id: '',
            ref_num: '',
            location_id: '',
            Location: '',
            location_details: '',
            location_name: '',
            location_address_1: '',
            location_address_2: '',
            location_suburb: '',
            location_postcode: '',
            Language: '',
            booking_received: '',
            service_date: '',
            service_time_start: '',
            service_time_end: '',
            service_date_formatted: '',
            create_date_formatted: '',
            service_start: '',
            service_end: '',
            service_start_date_time: '',
            service_end_date_time: '',
            interpreter_local_start: '',
            interpreter_local_end: '',
            interpreter_local_actual_start: '',
            interpreter_local_actual_end: '',
            job_local_start: '',
            job_local_end: '',
            booking_type: '',
            professional: '',
            location: '',
            Cancellation: '',
            not_serviced: '',
            Professional: '',
            interpreters_name: '',
            interpreters_surname: '',
            interpreting_category: '',
            translating_category: '',
            inter_trans: '',
            other_info: '',
            requested_by: '',
            other: '',
            category: '',
            cancellation: '',
            int_id: '',
            client_id: '',
            client_ref_no: '',
            minlength: '',
            booking_made_by_client: '',
            DEECD_activity: '',
            DEECD_activity_location: '',
            home_visit: '',
            video_link: '',
            // web_access: '',
            access_level: '',
            calds: [
                {
                    name: "",
                    reference: "",
                    start_time: "",
                    location: "",
                    professional: ""
                }
            ],
            job_session_id: 0
        }
    }

    options() {
        return {
            methods: {
                accept: 'POST',
                decline: 'POST',
                checkToken: 'POST',
                availUnavailable: 'POST'
            }
        }
    }

    routes() {
        return {
            fetch: 'interpreter/job',
            accept: 'interpreter/job/accept',
            decline: 'interpreter/job/decline',
            checkToken: 'interpreter/booking/check_token',
            availUnavailable: 'interpreter/job/available' // this is used for both available and unavailable
        }
    }

    bookingAccept(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.accept');
        let route = Vue.prototype.$interpretersApiUrl + '/' + this.getRoute('accept');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }

    bookingDecline(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.accept');
        let route = Vue.prototype.$interpretersApiUrl + '/' + this.getRoute('decline');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }

    bookingAvailUnavailable(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.availUnavailable');
        let route = Vue.prototype.$interpretersApiUrl + '/' + this.getRoute('availUnavailable');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }

    checkToken(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.checkToken');
        let route = Vue.prototype.$interpretersApiUrl + this.getRoute('checkToken');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }
}
